import { getRegionesPorPais, getProvinciasPorRegion, getComunaPorProvincia, getLocalidadesPorComuna } from "@/constants/administracion";


export default {
  namespaced: true,
  state: {
    // Variables para filtros
    dataListalistaClientes: [],
    dataListaRazonSocial: [],
    dataListaResponsable: [],
    dataListaFiliales: [],
    dataListaFilialesModal: [],
    dataListaUsuarios: [],
    dataListaEmails: [],
    dataListaNombreCompleto: [],
    dataListaRoles: [],
    dataListaRolesModal: [],
    dataListaClientes: [],
    dataListaClientesModal: [],
    dataListaNombres: [],
    dataListaTipos: [],
    dataListaBancos: [],
    dataListaTiposCuentas: [],
    dataListaPaises: [],

    //
    dataMantPaises: [],
    datamantRegiones: [],
    dataMantProvincia: [],
    dataMantComuna: [],
    dataMantLocalidad: [],

    // Variables para filtros
    dataListaPuertos: [],
    dataListaPuertosPaises: [],
    dataListaPuertosDestinos: [],
    dataListaPuertosCodigos: [],
    dataListaCodigosContenedores: [],
    dataListaInttraContenedores: [],
    dataListaCargoSmartContenedores: [],
    dataListaTipoContenedores: [],
    dataListaVolumenesContenedores: [],
    dataListaAnchosContenedores: [],
    dataListaAltosContenedores: [],
    dataListaLargosContenedores: [],
    //Aduanas
    dataDataListaAgenciaAduanas: [],
    dataDataListaEmpresas: [],
    dataDataListaClientes: [],
    // Depositos
    dataDepositosNombres: [],
    dataDepositosDirecciones: [],
    dataDepositosPaises: [],
    dataDepositosComunas: [],
    dataDepositosZonas: [],
    dataDepositosPuertos: [],

    // Variables para filtros
    dataListaCodigosPallets: [],
    dataListaDescripcionesPallets: [],
    dataListaLargosPallets: [],
    dataListaAnchosPallets: [],
    dataListaAreasPallets: [],
    dataListaPltstdPallets: [],

    // Naves
    dataNavesNombre: [],
    dataNavesTipo: [],
    dataNavesCodigoImo: [],
    dataNavesCapPallets: [],
    dataNavesCapRh: [],
    dataNavesCapTeu: [],
    dataNavesDescripcion: [],

    // Navieras
    dataNavieraNombre: [],
    dataNavieraScac: [],
    dataNavieraCargoSmart: [],
    dataNavieraLinea: [],
    dataNavieraCharter: [],
    dataNavieraInttra: [],

    // Productos
    dataProductosNombres: [],
    dataProductosCategorias: [],
    dataProductosContenedores: [],
    dataProductosAgregarCategorias: [],
    dataProductosAgregarContenedores: [],

    // temporadas
    dataTemporadasNumeroTier: [],
    dataTemporadasTipoTiers: [],
    // Clientes
    dataListaCategoriaProductoCliente: [],
    // Embarcado
    dataEmbarcadorNombres: [],
    dataEmbarcadorPaises: [],
    dataEmbarcadorTelefonos: [],

    //
    visibleModalInformacionGeneral: false,
    contenedores: [],

    // Ventanas modales
    visibleModalPermisosUsuarios: false,
    visibleModalManRegionalPaises: false,
    visibleModalManRegionalRegiones: false,
    visibleModalManRegionalProvincias: false,
    visibleModalManRegionalComunas: false,
    visibleModalManRegionalLocalidades: false,

    dataTiposProveedores: [],

    // Datatables
    dataEmbarcadores: [],
    dataEmbarcadores1: [],
    dataEmbarcadores2: [],
    dataResponsables: [],
    dataTiposClientes: [],
    dataTiposModulosSistema: [],
    dataClientesFiliales: [],
    dataPaisesDepositos: [],
    dataRegionesDepositos: [],
    dataProvinciasDepositos: [],
    dataZonasDepositos: [],
    dataComunasDepositos: [],
    dataLocalidadesDepositos: [],
    dataPuertosDepositos: [],
    dataTipoNaves: [],
    dataDias: [],
    dataSemanas: [],

    // DataTables
    dataDatatableFiliales: [],
    dataDatatableFilialesFiltrada: [],

    dataDatatableClientes: [],
    dataDatatableClientesFiltrada: [],
    dataDatatableClientesContactos: [],
    dataDatatableClientesDirecciones: [],
    dataDatatableClientesPlantas: [],
    dataDatatableClientesAgenciasAduana: [],
    dataDatatableClientesConsignatarios: [],
    dataDatatableClientesNotificados: [],
    dataDatatableClientesAfiliados: [],
    dataDatatableClientesProductos: [],
    dataDatatableDetalleClientesContactos: [],
    dataDatatableDetalleClientesDirecciones: [],
    dataDatatableDetalleClientesPlantas: [],
    dataDatatableDetalleClientesAgenciasAduana: [],
    dataDatatableDetalleClientesConsignatarios: [],
    dataDatatableDetalleClientesNotificados: [],
    dataDatatableDetalleClientesAfiliados: [],
    dataDatatableDetalleClientesProductos: [],
    dataDatatableUsuarios: [],
    dataDatatableUsuariosFiltrada: [],
    dataDatatableRoles: [],
    dataDatatableRolesFiltrada: [],
    dataDatatableProveedores: [],
    dataDatatableProveedoresFiltrada: [],
    dataDatatableProveedoresCoordinadores: [],
    dataDatatableProveedoresConductores: [],
    dataDatatableProveedoresCamiones: [],
    dataDatatableProveedoresDatosBancarios: [],
    dataDatatableMantenedorRegional: [],
    dataDatatableMantenedorRegionalFiltrada: [],
    dataDatatablePuertos: [],
    dataDatatablePuertosFiltrada: [],
    dataDatatableDestinos: [],
    dataDatatableDestinosFiltrada: [],
    dataDatatableContenedores: [],
    dataDatatableContenedoresFiltrada: [],
    dataDatatableDepositos: [],
    dataDatatableDepositosFiltrada: [],
    dataDatatableAtmosferas: [],
    dataDatatableAtmosferasFiltrada: [],
    dataDatatableMovimientos: [],
    dataDatatableMovimientosFiltrada: [],
    dataDatatableZonasConsolidacion: [],
    dataDatatableZonasConsolidacionFiltrada: [],
    dataDatatablePallets: [],
    dataDatatablePalletsFiltrada: [],
    dataDatatableCondiciones: [],
    dataDatatableCondicionesFiltrada: [],
    dataDatatableNaves: [],
    dataDatatableNavesFiltrada: [],
    dataDatatableNavieras: [],
    dataDatatableNavierasFiltrada: [],
    dataDatatableProductos: [],
    dataDatatableProductosFiltrada: [],
    dataDatatableEmbarcador: [],
    dataDatatableEmbarcadorFiltrada: [],
    dataDatatableEmbarcadoresDirecciones: [],
    dataDatatableEmbarcadoresContactos: [],

    dataDatatableLimitePlanificaciones: [],

    dataDatatableTemporadas: [],
    dataDatatableTemporadasTiers: [],
    dataDatatableEmpresas: [],

    // Variables auxiliares
    idAuxiliarClienteSeleccionado: "",
    idAuxiliarDetalleClienteSeleccionado: "",
    idAuxiliarPaisSeleccionado: "",
    idAuxiliarProveedorSeleccionado: "",
    idAuxiliarDetalleProveedorSeleccionado: "",
    idAuxiliarEmbarcadorSeleccionado: "",
    idTemporadaActual: "",
    indexTabActualTemporadas: "",
    cabecerasTemporadas: [],

    // ventanas modales

    visibleModalEditarClientesContactos: false,
    visibleModalEditarClientesDirecciones: false,
    visibleModalEditarClientesPlantas: false,
    visibleModalEditarClientesAgenciasAduana: false,
    visibleModalEditarClientesConsignatarios: false,
    visibleModalEditarClientesNotificados: false,
    visibleModalEditarClientesAfiliados: false,
    visibleModalEditarClientesProductos: false,

    //Ventanas editar - Proveedores

    visibleModalEditarProveedoresCoordinadores: false,
    visibleModalEditarProveedoresConductores: false,
    visibleModalEditarProveedoresCamiones: false,
    visibleModalEditarProveedoresDatosBancarios: false,

    //Ventanas editar - Contenedores

    visibleModalEditarContenedoresContenedores: false,
    visibleModalEditarContenedoresDepositos: false,
    visibleModalEditarContenedoresAtmosferas: false,
    visibleModalEditarContenedoresTiposMovimiento: false,
    visibleModalEditarContenedoresZonasConsolidacion: false,

    visibleModalEditarEmbarcadorDirecciones: false,
    visibleModalEditarEmbarcadorContactos: false,

    visibleModalEditarTemporada: false,
    //usuarios
    userStructure: [],
    //tiers
    tiers: [],
    loadingTableTiersAdmin: false,
    showModalEditarTier: false,
    //end tiers
    
    mantenedorRegionalFlagCounter: 0,

    dataRegiones : [],
    isLoadingRegiones: false,

    dataProvincias : [],
    isLoadingProvincias: false,

    dataComunas : [],
    isLoadingComunas: false,

    dataLocalidades : [],
    isLoadingLocalidades: false,

  },

  // 2
  mutations: {
    /*
    
      Variables auxiliares
    
    */

    setIdAuxiliarClienteSeleccionado(state, payload) {
      state.idAuxiliarClienteSeleccionado = payload;
    },

    setIdAuxiliarDetalleClienteSeleccionado(state, payload) {
      state.idAuxiliarDetalleClienteSeleccionado = payload;
    },

    setIdAuxiliarPaisSeleccionado(state, payload) {
      state.idAuxiliarPaisSeleccionado = payload;
    },

    setIdAuxiliarProveedorSeleccionado(state, payload) {
      state.idAuxiliarProveedorSeleccionado = payload;
    },

    setIdAuxiliarDetalleProveedorSeleccionado(state, payload) {
      state.idAuxiliarDetalleProveedorSeleccionado = payload;
    },

    setIdAuxiliarEmbarcadorSeleccionado(state, payload) {
      state.idAuxiliarEmbarcadorSeleccionado = payload;
    },

    setIdTemporadaActual(state, payload) {
      state.idTemporadaActual = payload;
    },

    setIndexTabActualTemporadas(state, payload) {
      state.indexTabActualTemporadas = payload;
    },

    setCabecerasTemporadas(state, payload) {
      state.cabecerasTemporadas = payload;
    },

    /*
    
      Variables auxiliares Filtros
    
    */

    setDataListalistaClientes(state, payload) {
      state.dataListalistaClientes = payload;
    },

    setDataListaRazonSocial(state, payload) {
      state.dataListaRazonSocial = payload;
    },

    setDataListaResponsable(state, payload) {
      state.dataListaResponsable = payload;
    },

    setDataListaFiliales(state, payload) {
      state.dataListaFiliales = payload;
    },

    setDataListaFilialesModal(state, payload) {
      state.dataListaFilialesModal = payload;
    },

    /* Vista usuarios */
    setDataListaUsuarios(state, payload) {
      state.dataListaUsuarios = payload;
    },

    setDataListaEmails(state, payload) {
      state.dataListaEmails = payload;
    },

    setDataListaNombreCompleto(state, payload) {
      state.dataListaNombreCompleto = payload;
    },

    setDataListaRoles(state, payload) {
      state.dataListaRoles = payload;
    },

    setDataListaRolesModal(state, payload) {
      state.dataListaRolesModal = payload;
    },

    setDataListaClientes(state, payload) {
      state.dataListaClientes = payload;
    },

    setDataListaClientesModal(state, payload) {
      state.dataListaClientesModal = payload;
    },

    // Ventanas modales
    setVisibleModalPermisosUsuarios(state, payload) {
      state.visibleModalPermisosUsuarios = payload;
    },

    setVisibleModalManRegionalPaises(state, payload) {
      state.visibleModalManRegionalPaises = payload;
    },

    setVisibleModalManRegionalRegiones(state, payload) {
      state.visibleModalManRegionalRegiones = payload;
    },

    setVisibleModalManRegionalProvincias(state, payload) {
      state.visibleModalManRegionalProvincias = payload;
    },

    setVisibleModalManRegionalComunas(state, payload) {
      state.visibleModalManRegionalComunas = payload;
    },

    setVisibleModalManRegionalLocalidades(state, payload) {
      state.visibleModalManRegionalLocalidades = payload;
    },

    /* Vista Proveedores */

    setDataListaNombres(state, payload) {
      state.dataListaNombres = payload;
    },

    setDataListaTipos(state, payload) {
      state.dataListaTipos = payload;
    },

    setDataListaPaises(state, payload) {
      state.dataListaPaises = payload;
    },

    setDataListaEmbarcadores(state, payload) {
      state.dataListaEmbarcadores = payload;
    },

    setDataListaBancos(state, payload) {
      state.dataListaBancos = payload;
    },

    setDataListaTiposCuentas(state, payload) {
      state.dataListaTiposCuentas = payload;
    },

    /* Vista Mantenedor Regional */

    setDataMantPaises(state, payload) {
      state.dataMantPaises = payload;
    },

    setDataMantRegiones(state, payload) {
      state.dataMantRegiones = payload;
    },

    setDataMantProvincia(state, payload) {
      state.dataMantProvincia = payload;
    },

    setDataMantComuna(state, payload) {
      state.dataMantComuna = payload;
    },

    setDataMantLocalidad(state, payload) {
      state.dataMantLocalidad = payload;
    },

    /* Vista Puertos */

    setDataListaPuertos(state, payload) {
      state.dataListaPuertos = payload;
    },

    setDataListaPuertosPaises(state, payload) {
      state.dataListaPuertosPaises = payload;
    },

    setDataListaPuertosDestinos(state, payload) {
      state.dataListaPuertosDestinos = payload;
    },

    setDataListaPuertosCodigos(state, payload) {
      state.dataListaPuertosCodigos = payload;
    },

    /* Vista Contenedores */

    setDataListaCodigosContenedores(state, payload) {
      state.dataListaCodigosContenedores = payload;
    },

    setDataListaInttraContenedores(state, payload) {
      state.dataListaInttraContenedores = payload;
    },

    setDataListaCargoSmartContenedores(state, payload) {
      state.dataListaCargoSmartContenedores = payload;
    },

    setDataListaTipoContenedores(state, payload) {
      state.dataListaTipoContenedores = payload;
    },

    setDataListaVolumenesContenedores(state, payload) {
      state.dataListaVolumenesContenedores = payload;
    },

    setDataListaAnchosContenedores(state, payload) {
      state.dataListaAnchosContenedores = payload;
    },

    setDataListaAltosContenedores(state, payload) {
      state.dataListaAltosContenedores = payload;
    },

    setDataListaLargosContenedores(state, payload) {
      state.dataListaLargosContenedores = payload;
    },

    /* Vista Depositos */

    setDataDepositosNombres(state, payload) {
      state.dataDepositosNombres = payload;
    },

    setDataDepositosDirecciones(state, payload) {
      state.dataDepositosDirecciones = payload;
    },

    setDataDepositosPaises(state, payload) {
      state.dataDepositosPaises = payload;
    },

    setDataDepositosZonas(state, payload) {
      state.dataDepositosZonas = payload;
    },

    setDataDepositosComunas(state, payload) {
      state.dataDepositosComunas = payload;
    },

    setDataDepositosPuertos(state, payload) {
      state.dataDepositosPuertos = payload;
    },

    setDataPaisesDepositos(state, payload) {
      state.dataPaisesDepositos = payload;
    },
    setDataRegionesDepositos(state, payload) {
      state.dataRegionesDepositos = payload;
    },
    setDataProvinciasDepositos(state, payload) {
      state.dataProvinciasDepositos = payload;
    },

    setDataZonasDepositos(state, payload) {
      state.dataZonasDepositos = payload;
    },

    setDataComunasDepositos(state, payload) {
      state.dataComunasDepositos = payload;
    },
    setDataLocalidadesDepositos(state, payload) {
      state.dataLocalidadesDepositos = payload;
    },
    setDataPuertosDepositos(state, payload) {
      state.dataPuertosDepositos = payload;
    },

    /* Vista Pallets */

    setDataListaCodigosPallets(state, payload) {
      state.dataListaCodigosPallets = payload;
    },

    setDataListaDescripcionesPallets(state, payload) {
      state.dataListaDescripcionesPallets = payload;
    },

    setDataListaLargosPallets(state, payload) {
      state.dataListaLargosPallets = payload;
    },

    setDataListaAnchosPallets(state, payload) {
      state.dataListaAnchosPallets = payload;
    },

    setDataListaAreasPallets(state, payload) {
      state.dataListaAreasPallets = payload;
    },

    setDataListaPltstdPallets(state, payload) {
      state.dataListaPltstdPallets = payload;
    },

    /* Vista Naves */

    setDataNavesNombre(state, payload) {
      state.dataNavesNombre = payload;
    },

    setDataNavesTipo(state, payload) {
      state.dataNavesTipo = payload;
    },

    setDataNavesCodigoImo(state, payload) {
      state.dataNavesCodigoImo = payload;
    },

    setDataNavesCapPallets(state, payload) {
      state.dataNavesCapPallets = payload;
    },

    setDataNavesCapRh(state, payload) {
      state.dataNavesCapRh = payload;
    },

    setDataNavesCapTeu(state, payload) {
      state.dataNavesCapTeu = payload;
    },

    setDataNavesDescripcion(state, payload) {
      state.dataNavesDescripcion = payload;
    },

    setDataTipoNaves(state, payload) {
      state.dataTipoNaves = payload;
    },

    setDataDias(state, payload) {
      state.dataDias = payload;
    },

    setDataSemanas(state, payload) {
      state.dataSemanas = payload;
    },

    /* Vista Navieras */

    setDataNavieraNombre(state, payload) {
      state.dataNavieraNombre = payload;
    },

    setDataNavieraScac(state, payload) {
      state.dataNavieraScac = payload;
    },

    setDataNavieraCargoSmart(state, payload) {
      state.dataNavieraCargoSmart = payload;
    },

    setDataNavieraLinea(state, payload) {
      state.dataNavieraLinea = payload;
    },

    setDataNavieraCharter(state, payload) {
      state.dataNavieraCharter = payload;
    },

    setDataNavieraInttra(state, payload) {
      state.dataNavieraInttra = payload;
    },

    /* Vista Limite Planificaciones */

    /* Vista Productos */

    setDataProductosNombres(state, payload) {
      state.dataProductosNombres = payload;
    },

    setDataProductosCategorias(state, payload) {
      state.dataProductosCategorias = payload;
    },

    setDataProductosContenedores(state, payload) {
      state.dataProductosContenedores = payload;
    },

    setDataProductosAgregarCategorias(state, payload) {
      state.dataProductosAgregarCategorias = payload;
    },

    setDataProductosAgregarContenedores(state, payload) {
      state.dataProductosAgregarContenedores = payload;
    },

    /* Vista Embarcador */

    setDataEmbarcadorNombres(state, payload) {
      state.dataEmbarcadorNombres = payload;
    },

    setDataEmbarcadorPaises(state, payload) {
      state.dataEmbarcadorPaises = payload;
    },

    setDataEmbarcadorTelefonos(state, payload) {
      state.dataEmbarcadorTelefonos = payload;
    },

    /*
    
      Variables auxiliares Modal
    
    */
    setDataEmbarcadores(state, payload) {
      state.dataEmbarcadores = payload;
    },

    setDataResponsables(state, payload) {
      state.dataResponsables = payload;
    },

    setDataTiposClientes(state, payload) {
      state.dataTiposClientes = payload;
    },

    setDataTiposModulosSistema(state, payload) {
      state.dataTiposModulosSistema = payload;
    },

    setDataClientesFiliales(state, payload) {
      state.dataClientesFiliales = payload;
    },

    setDataTiposProveedores(state, payload) {
      state.dataTiposProveedores = payload;
    },

    // clientes
    setVisibleModalEditarClientesContactos(state, payload) {
      state.visibleModalEditarClientesContactos = payload;
    },

    setVisibleModalEditarClientesDirecciones(state, payload) {
      state.visibleModalEditarClientesDirecciones = payload;
    },

    setVisibleModalEditarClientesPlantas(state, payload) {
      state.visibleModalEditarClientesPlantas = payload;
    },

    setVisibleModalEditarClientesAgenciasAduana(state, payload) {
      state.visibleModalEditarClientesAgenciasAduana = payload;
    },

    setVisibleModalEditarClientesConsignatarios(state, payload) {
      state.visibleModalEditarClientesConsignatarios = payload;
    },

    setVisibleModalEditarClientesNotificados(state, payload) {
      state.visibleModalEditarClientesNotificados = payload;
    },

    setVisibleModalEditarClientesAfiliados(state, payload) {
      state.visibleModalEditarClientesAfiliados = payload;
    },

    setVisibleModalEditarClientesProductos(state, payload) {
      state.visibleModalEditarClientesProductos = payload;
    },

    // Proveedores

    setVisibleModalEditarProveedoresCoordinadores(state, payload) {
      state.visibleModalEditarProveedoresCoordinadores = payload;
    },

    setVisibleModalEditarProveedoresConductores(state, payload) {
      state.visibleModalEditarProveedoresConductores = payload;
    },

    setVisibleModalEditarProveedoresCamiones(state, payload) {
      state.visibleModalEditarProveedoresCamiones = payload;
    },

    setVisibleModalEditarProveedoresDatosBancarios(state, payload) {
      state.visibleModalEditarProveedoresDatosBancarios = payload;
    },

    setVisibleModalEditarContenedoresContenedores(state, payload) {
      state.visibleModalEditarContenedoresContenedores = payload;
    },

    setVisibleModalEditarContenedoresDepositos(state, payload) {
      state.visibleModalEditarContenedoresDepositos = payload;
    },

    setVisibleModalEditarContenedoresAtmosferas(state, payload) {
      state.visibleModalEditarContenedoresAtmosferas = payload;
    },

    setVisibleModalEditarContenedoresTiposMovimiento(state, payload) {
      state.visibleModalEditarContenedoresTiposMovimiento = payload;
    },

    setVisibleModalEditarContenedoresZonasConsolidacion(state, payload) {
      state.visibleModalEditarContenedoresZonasConsolidacion = payload;
    },

    setVisibleModalEditarEmbarcadorDirecciones(state, payload) {
      state.visibleModalEditarEmbarcadorDirecciones = payload;
    },

    setVisibleModalEditarEmbarcadorContactos(state, payload) {
      state.visibleModalEditarEmbarcadorContactos = payload;
    },

    /*



    
      Mutaciones para Datatables

    */
    setDataFiliales(state, payload) {
      state.dataDatatableFiliales = payload;
      state.dataDatatableFilialesFiltrada = payload;
    },

    filterDataFiliales(state, payload) {
      state.dataDatatableFilialesFiltrada = state.dataDatatableFiliales;
      state.dataDatatableFilialesFiltrada = payload;
    },

    limpiarDataFiliales(state) {
      state.dataDatatableFilialesFiltrada = state.dataDatatableFiliales;
    },

    setvisibleModalInformacionGeneral(state, payload) {
      state.visibleModalInformacionGeneral = payload;
    },

    setVisibleModalEditarTemporada(state, payload) {
      state.visibleModalEditarTemporada = payload;
    },

    setDataClientes(state, payload) {
      state.dataDatatableClientes = payload;
      state.dataDatatableClientesFiltrada = payload;
    },

    setDataClientesContactos(state, payload) {
      state.dataDatatableClientesContactos = payload;
    },

    setDataClientesDirecciones(state, payload) {
      state.dataDatatableClientesDirecciones = payload;
    },

    setDataClientesPlantas(state, payload) {
      state.dataDatatableClientesPlantas = payload;
    },

    setDataClientesAgenciasAduana(state, payload) {
      state.dataDatatableClientesAgenciasAduana = payload;
    },

    setDataClientesConsignatarios(state, payload) {
      state.dataDatatableClientesConsignatarios = payload;
    },

    setDataClientesNotificados(state, payload) {
      state.dataDatatableClientesNotificados = payload;
    },

    setDataClientesAfiliados(state, payload) {
      state.dataDatatableClientesAfiliados = payload;
    },

    setDataClientesProductos(state, payload) {
      state.dataDatatableClientesProductos = payload;
    },

    setDataDetalleClientesContactos(state, payload) {
      state.dataDatatableDetalleClientesContactos = payload;
    },

    setDataDetalleClientesDirecciones(state, payload) {
      state.dataDatatableDetalleClientesDirecciones = payload;
    },

    setDataDetalleClientesPlantas(state, payload) {
      state.dataDatatableDetalleClientesPlantas = payload;
    },

    setDataDetalleClientesAgenciasAduana(state, payload) {
      state.dataDatatableDetalleClientesAgenciasAduana = payload;
    },

    setDataDetalleClientesConsignatarios(state, payload) {
      state.dataDatatableDetalleClientesConsignatarios = payload;
    },

    setDataDetalleClientesNotificados(state, payload) {
      state.dataDatatableDetalleClientesNotificados = payload;
    },

    setDataDetalleClientesAfiliados(state, payload) {
      state.dataDatatableDetalleClientesAfiliados = payload;
    },

    setDataDetalleClientesProductos(state, payload) {
      state.dataDatatableDetalleClientesProductos = payload;
    },

    filterDataClientes(state, payload) {
      state.dataDatatableClientesFiltrada = state.dataDatatableClientes;
      state.dataDatatableClientesFiltrada = payload;
    },

    limpiarDataClientes(state) {
      state.dataDatatableClientesFiltrada = state.dataDatatableClientes;
    },

    setDataUsuarios(state, payload) {
      state.dataDatatableUsuarios = payload;
      state.dataDatatableUsuariosFiltrada = payload;
    },

    filterDataUsuarios(state, payload) {
      state.dataDatatableUsuariosFiltrada = state.dataDatatableUsuarios;
      state.dataDatatableUsuariosFiltrada = payload;
    },

    limpiarDataUsuarios(state) {
      state.dataDatatableUsuariosFiltrada = state.dataDatatableUsuarios;
    },

    setDataRoles(state, payload) {
      state.dataDatatableRoles = payload;
      state.dataDatatableRolesFiltrada = payload;
    },

    setDataProveedores(state, payload) {
      state.dataDatatableProveedores = payload;
      state.dataDatatableProveedoresFiltrada = payload;
    },

    setDataProveedoresCoordinadores(state, payload) {
      state.dataDatatableProveedoresCoordinadores = payload;
    },

    setDataProveedoresConductores(state, payload) {
      state.dataDatatableProveedoresConductores = payload;
    },

    setDataProveedoresCamiones(state, payload) {
      state.dataDatatableProveedoresCamiones = payload;
    },

    setDataProveedoresDatosBancarios(state, payload) {
      state.dataDatatableProveedoresDatosBancarios = payload;
    },

    filterDataProveedores(state, payload) {
      state.dataDatatableProveedoresFiltrada = state.dataDatatableProveedores;
      state.dataDatatableProveedoresFiltrada = payload;
    },

    limpiarDataProveedores(state) {
      state.dataDatatableProveedoresFiltrada = state.dataDatatableProveedores;
    },

    setDataMantenedorRegional(state, payload) {
      state.dataDatatableMantenedorRegional = payload;
      state.dataDatatableMantenedorRegionalFiltrada = payload;
    },

    filterDataMantenedorRegional(state, payload) {
      state.dataDatatableMantenedorRegionalFiltrada =
        state.dataDatatableMantenedorRegional;
      state.dataDatatableMantenedorRegionalFiltrada = payload;
    },

    limpiarDataMantenedorRegional(state) {
      state.dataDatatableMantenedorRegionalFiltrada =
        state.dataDatatableMantenedorRegional;
    },

    setDataPuertos(state, payload) {
      state.dataDatatablePuertos = payload;
      state.dataDatatablePuertosFiltrada = payload;
    },

    filterDataPuertos(state, payload) {
      state.dataDatatablePuertos = state.dataDatatablePuertosFiltrada;
      state.dataDatatablePuertosFiltrada = payload;
    },

    limpiarDataPuertos(state) {
      state.dataDatatablePuertosFiltrada = state.dataDatatablePuertos;
    },

    setDataDestinos(state, payload) {
      state.dataDatatableDestinos = payload;
      state.dataDatatableDestinosFiltrada = payload;
    },

    setDataContenedores(state, payload) {
      state.dataDatatableContenedores = payload;
      state.dataDatatableContenedoresFiltrada = payload;
    },

    setContenedores(state, payload) {
      state.contenedores = payload;
    },

    filterDataContenedores(state, payload) {
      state.dataDatatableContenedoresFiltrada = state.dataDatatableContenedores;
      state.dataDatatableContenedoresFiltrada = payload;
    },

    limpiarDataContenedores(state) {
      state.dataDatatableContenedoresFiltrada = state.dataDatatableContenedores;
    },

    setDataDepositos(state, payload) {
      state.dataDatatableDepositos = payload;
      state.dataDatatableDepositosFiltrada = payload;
    },

    filterDataDepositos(state, payload) {
      state.dataDatatableDepositosFiltrada = state.dataDatatableDepositos;
      state.dataDatatableDepositosFiltrada = payload;
    },

    limpiarDataDepositos(state) {
      state.dataDatatableDepositosFiltrada = state.dataDatatableDepositos;
    },

    setDataAtmosferas(state, payload) {
      state.dataDatatableAtmosferas = payload;
      state.dataDatatableAtmosferasFiltrada = payload;
    },

    setDataMovimientos(state, payload) {
      state.dataDatatableMovimientos = payload;
      state.dataDatatableMovimientosFiltrada = payload;
    },

    setDataZonasConsolidacion(state, payload) {
      state.dataDatatableZonasConsolidacion = payload;
      state.dataDatatableZonasConsolidacionFiltrada = payload;
    },

    setDataPallets(state, payload) {
      state.dataDatatablePallets = payload;
      state.dataDatatablePalletsFiltrada = payload;
    },

    filterDataPallets(state, payload) {
      state.dataDatatablePalletsFiltrada = state.dataDatatablePallets;
      state.dataDatatablePalletsFiltrada = payload;
    },

    limpiarDataPallets(state) {
      state.dataDatatablePalletsFiltrada = state.dataDatatablePallets;
    },

    setDataCondiciones(state, payload) {
      state.dataDatatableCondiciones = payload;
      state.dataDatatableCondicionesFiltrada = payload;
    },

    setDataNaves(state, payload) {
      state.dataDatatableNaves = payload;
      state.dataDatatableNavesFiltrada = payload;
    },

    filterDataNaves(state, payload) {
      state.dataDatatableNavesFiltrada = state.dataDatatableNaves;
      state.dataDatatableNavesFiltrada = payload;
    },

    limpiarDataNaves(state) {
      state.dataDatatableNavesFiltrada = state.dataDatatableNaves;
    },

    setDataNavieras(state, payload) {
      state.dataDatatableNavieras = payload;
      state.dataDatatableNavierasFiltrada = payload;
    },

    filterDataNavieras(state, payload) {
      state.dataDatatableNavierasFiltrada = state.dataDatatableNavieras;
      state.dataDatatableNavierasFiltrada = payload;
    },

    limpiarDataNavieras(state) {
      state.dataDatatableNavierasFiltrada = state.dataDatatableNavieras;
    },

    setDataProductos(state, payload) {
      state.dataDatatableProductos = payload;
      state.dataDatatableProductosFiltrada = payload;
    },

    filterDataProductos(state, payload) {
      state.dataDatatableProductosFiltrada = state.dataDatatableProductos;
      state.dataDatatableProductosFiltrada = payload;
    },

    limpiarDataProductos(state) {
      state.dataDatatableProductosFiltrada = state.dataDatatableProductos;
    },

    setDataEmbarcador(state, payload) {
      state.dataDatatableEmbarcador = payload;
      state.dataDatatableEmbarcadorFiltrada = payload;
    },

    setDataEmbarcadoresDirecciones(state, payload) {
      state.dataDatatableEmbarcadoresDirecciones = payload;
    },

    setDataEmbarcadoresContactos(state, payload) {
      state.dataDatatableEmbarcadoresContactos = payload;
    },

    filterDataEmbarcador(state, payload) {
      state.dataDatatableEmbarcadorFiltrada = state.dataDatatableEmbarcador;
      state.dataDatatableEmbarcadorFiltrada = payload;
    },

    limpiarDataEmbarcador(state) {
      state.dataDatatableEmbarcadorFiltrada = state.dataDatatableEmbarcador;
    },

    setDataLimitePlanificaciones(state, payload) {
      state.dataDatatableLimitePlanificaciones = payload;
    },

    setDataTemporadasTiers(state, payload) {
      state.dataDatatableTemporadasTiers = payload;
    },

    setDataTemporadasNumeroTier(state, payload) {
      state.dataTemporadasNumeroTier = payload;
    },

    setDataTemporadasTipoTiers(state, payload) {
      state.dataTemporadasTipoTiers = payload;
    },

    setDataTemporadas(state, payload) {
      state.dataDatatableTemporadas = payload;
    },

    setDataEmpresas(state, payload) {
      state.dataDatatableEmpresas = payload;
    },

    setDataListaAgenciaAduana(state, payload) {
      state.dataDataListaAgenciaAduanas = payload;
    },

    setDataListaEmpresas(state, payload) {
      state.dataDataListaEmpresas = payload;
    },

    setDataDataListaClientes(state, payload) {
      state.dataDataListaClientes = payload;
    },

    setDataListaCategoriaProductoCliente(state, payload) {
      state.dataListaCategoriaProductoCliente = payload;
    },

    setUserStructure(state, payload) {
      state.userStructure = payload;
    },
    setTiers(state, payload) {
      state.tiers = payload;
    },
    setLoadingTableTiersAdmin(state, payload) {
      state.loadingTableTiersAdmin = payload;
    },
    setShowModalEditarTier(state, payload) {
      state.showModalEditarTier = payload;
    },

    async setDataRegiones(state, payload){
      state.isLoadingRegiones = true;
      state.dataRegiones = await getRegionesPorPais(payload);
      state.isLoadingRegiones = false;
    },
    async setDataProvincias(state, payload){
      state.isLoadingProvincias = true;
      state.dataProvincias = await getProvinciasPorRegion(payload);
      state.isLoadingProvincias = false;
    },
    async setDataComunas(state, payload){
      state.isLoadingComunas = true;
      state.dataComunas = await getComunaPorProvincia(payload);
      state.isLoadingComunas = false;
    },
    async setDataLocalidades(state, payload){
      state.isLoadingLocalidades = true;
      state.dataLocalidades = await getLocalidadesPorComuna(payload);
      state.isLoadingLocalidades = false;
    },

  },

  // 1
  actions: {
    /*
     Acciones Auxiliares  
    
    */

    actionSetIdAuxiliarClienteSeleccionado({ commit }, data) {
      commit("setIdAuxiliarClienteSeleccionado", data);
    },

    actionSetIdAuxiliarDetalleClienteSeleccionado({ commit }, data) {
      commit("setIdAuxiliarDetalleClienteSeleccionado", data);
    },

    actionSetIdAuxiliarPaisSeleccionado({ commit }, data) {
      commit("setIdAuxiliarPaisSeleccionado", data);
    },

    actionSetIdAuxiliarProveedorSeleccionado({ commit }, data) {
      commit("setIdAuxiliarProveedorSeleccionado", data);
    },

    actionSetIdAuxiliarDetalleProveedorSeleccionado({ commit }, data) {
      commit("setIdAuxiliarDetalleProveedorSeleccionado", data);
    },

    actionSetIdAuxiliarEmbarcadorSeleccionado({ commit }, data) {
      commit("setIdAuxiliarEmbarcadorSeleccionado", data);
    },

    actionSetIdTemporadaActual({ commit }, data) {
      commit("setIdTemporadaActual", data);
    },

    actionSetIndexTabActualTemporadas({ commit }, data) {
      commit("setIndexTabActualTemporadas", data);
    },

    actionSetCabecerasTemporadas({ commit }, data) {
      commit("setCabecerasTemporadas", data);
    },

    /*
     Acciones Auxiliares para filtros  
    
    */

    actionSetDataListalistaClientes({ commit }, data) {
      commit("setDataListalistaClientes", data);
    },

    actionSetDataListaResponsable({ commit }, data) {
      commit("setDataListaResponsable", data);
    },

    /* Ventanas modales */
    actionSetVisibleModalPermisosUsuarios({ commit }, data) {
      commit("setVisibleModalPermisosUsuarios", data);
    },

    actionSetVisibleModalManRegionalPaises({ commit }, data) {
      commit("setVisibleModalManRegionalPaises", data);
    },

    actionSetVisibleModalManRegionalRegiones({ commit }, data) {
      commit("setVisibleModalManRegionalRegiones", data);
    },

    actionSetVisibleModalManRegionalProvincias({ commit }, data) {
      commit("setVisibleModalManRegionalProvincias", data);
    },

    actionSetVisibleModalManRegionalComunas({ commit }, data) {
      commit("setVisibleModalManRegionalComunas", data);
    },

    actionSetVisibleModalManRegionalLocalidades({ commit }, data) {
      commit("setVisibleModalManRegionalLocalidades", data);
    },

    /* Vista filiales */

    actionSetDataListaFiliales({ commit }, data) {
      commit("setDataListaFiliales", data);
    },

    actionSetDataListaRazonSocial({ commit }, data) {
      commit("setDataListaRazonSocial", data);
    },

    actionSetDataListaFilialesModal({ commit }, data) {
      commit("setDataListaFilialesModal", data);
    },

    /* Vista usuarios */

    actionSetDataListaUsuarios({ commit }, data) {
      commit("setDataListaUsuarios", data);
    },

    actionSetDataListaEmails({ commit }, data) {
      commit("setDataListaEmails", data);
    },

    actionSetDataListaNombreCompleto({ commit }, data) {
      commit("setDataListaNombreCompleto", data);
    },

    actionSetDataListaRoles({ commit }, data) {
      commit("setDataListaRoles", data);
    },

    actionSetDataListaRolesModal({ commit }, data) {
      commit("setDataListaRolesModal", data);
    },

    actionSetDataListaClientes({ commit }, data) {
      commit("setDataListaClientes", data);
    },

    actionSetDataListaClientesModal({ commit }, data) {
      commit("setDataListaClientesModal", data);
    },

    /* Vista Mantenedor Regional */

    actionSetDataMantPaises({ commit }, data) {
      commit("setDataMantPaises", data);
    },

    actionSetDataMantRegiones({ commit }, data) {
      commit("setDataMantRegiones", data);
    },

    actionSetDataMantProvincia({ commit }, data) {
      commit("setDataMantProvincia", data);
    },

    actionSetDataMantComuna({ commit }, data) {
      commit("setDataMantComuna", data);
    },

    actionSetDataMantLocalidad({ commit }, data) {
      commit("setDataMantLocalidad", data);
    },

    /* Vista Proveedores */

    actionSetDataListaNombres({ commit }, data) {
      commit("setDataListaNombres", data);
    },

    actionSetDataListaTipos({ commit }, data) {
      commit("setDataListaTipos", data);
    },

    actionSetDataListaPaises({ commit }, data) {
      commit("setDataListaPaises", data);
    },

    actionSetDataListaEmbarcadores({ commit }, data) {
      commit("setDataListaEmbarcadores", data);
    },

    actionSetDataListaBancos({ commit }, data) {
      commit("setDataListaBancos", data);
    },

    actionSetDataListaTiposCuentas({ commit }, data) {
      commit("setDataListaTiposCuentas", data);
    },

    /* Vista Puertos */

    actionSetDataListaPuertos({ commit }, data) {
      commit("setDataListaPuertos", data);
    },

    actionSetDataListaPuertosPaises({ commit }, data) {
      commit("setDataListaPuertosPaises", data);
    },

    actionSetDataListaPuertosDestinos({ commit }, data) {
      commit("setDataListaPuertosDestinos", data);
    },

    actionSetDataListaPuertosCodigos({ commit }, data) {
      commit("setDataListaPuertosCodigos", data);
    },

    /* Vista Contenedores */

    actionSetDataListaCodigosContenedores({ commit }, data) {
      commit("setDataListaCodigosContenedores", data);
    },

    actionSetDataListaInttraContenedores({ commit }, data) {
      commit("setDataListaInttraContenedores", data);
    },

    actionSetDataListaCargoSmartContenedores({ commit }, data) {
      commit("setDataListaCargoSmartContenedores", data);
    },

    actionSetDataListaTipoContenedores({ commit }, data) {
      commit("setDataListaTipoContenedores", data);
    },

    actionSetDataListaVolumenesContenedores({ commit }, data) {
      commit("setDataListaVolumenesContenedores", data);
    },

    actionSetDataListaAnchosContenedores({ commit }, data) {
      commit("setDataListaAnchosContenedores", data);
    },

    actionSetDataListaAltosContenedores({ commit }, data) {
      commit("setDataListaAltosContenedores", data);
    },

    actionSetDataListaLargosContenedores({ commit }, data) {
      commit("setDataListaLargosContenedores", data);
    },

    actionSetContenedores({ commit }, data) {
      commit("setContenedores", data);
    },

    /* Vista Depositos */

    actionSetDataDepositosNombres({ commit }, data) {
      commit("setDataDepositosNombres", data);
    },

    actionSetDataDepositosDirecciones({ commit }, data) {
      commit("setDataDepositosDirecciones", data);
    },

    actionSetDataDepositosPaises({ commit }, data) {
      commit("setDataDepositosPaises", data);
    },

    actionSetDataDepositosComunas({ commit }, data) {
      commit("setDataDepositosComunas", data);
    },

    actionSetDataDepositosZonas({ commit }, data) {
      commit("setDataDepositosZonas", data);
    },

    actionSetDataDepositosPuertos({ commit }, data) {
      commit("setDataDepositosPuertos", data);
    },

    actionSetDataPaisesDepositos({ commit }, data) {
      commit("setDataPaisesDepositos", data);
    },
    actionSetDataRegionesDepositos({ commit }, data) {
      commit("setDataRegionesDepositos", data);
    },
    actionSetDataProvinciasDepositos({ commit }, data) {
      commit("setDataProvinciasDepositos", data);
    },
    actionSetDataZonasDepositos({ commit }, data) {
      commit("setDataZonasDepositos", data);
    },
    actionSetDataComunasDepositos({ commit }, data) {
      commit("setDataComunasDepositos", data);
    },
    actionSetDataLocalidadesDepositos({ commit }, data) {
      commit("setDataLocalidadesDepositos", data);
    },
    actionSetDataPuertosDepositos({ commit }, data) {
      commit("setDataPuertosDepositos", data);
    },

    /* Vista Pallets */

    actionSetDataListaCodigosPallets({ commit }, data) {
      commit("setDataListaCodigosPallets", data);
    },

    actionSetDataListaDescripcionesPallets({ commit }, data) {
      commit("setDataListaDescripcionesPallets", data);
    },

    actionSetDataListaLargosPallets({ commit }, data) {
      commit("setDataListaLargosPallets", data);
    },

    actionSetDataListaAnchosPallets({ commit }, data) {
      commit("setDataListaAnchosPallets", data);
    },

    actionSetDataListaAreasPallets({ commit }, data) {
      commit("setDataListaAreasPallets", data);
    },

    actionSetDataListaPltstdPallets({ commit }, data) {
      commit("setDataListaPltstdPallets", data);
    },

    /* Vista Naves */

    actionSetDataNavesNombre({ commit }, data) {
      commit("setDataNavesNombre", data);
    },

    actionSetDataNavesTipo({ commit }, data) {
      commit("setDataNavesTipo", data);
    },

    actionSetDataNavesCodigoImo({ commit }, data) {
      commit("setDataNavesCodigoImo", data);
    },

    actionSetDataNavesCapPallets({ commit }, data) {
      commit("setDataNavesCapPallets", data);
    },

    actionSetDataNavesCapRh({ commit }, data) {
      commit("setDataNavesCapRh", data);
    },

    actionSetDataNavesCapTeu({ commit }, data) {
      commit("setDataNavesCapTeu", data);
    },

    actionSetDataNavesDescripcion({ commit }, data) {
      commit("setDataNavesDescripcion", data);
    },

    actionSetDataTipoNaves({ commit }, data) {
      commit("setDataTipoNaves", data);
    },

    actionSetDataDias({ commit }, data) {
      commit("setDataDias", data);
    },

    actionSetDataSemanas({ commit }, data) {
      commit("setDataSemanas", data);
    },

    /* Vista Navieras */

    actionSetDataNavieraNombre({ commit }, data) {
      commit("setDataNavieraNombre", data);
    },

    actionSetDataNavieraScac({ commit }, data) {
      commit("setDataNavieraScac", data);
    },

    actionSetDataNavieraCargoSmart({ commit }, data) {
      commit("setDataNavieraCargoSmart", data);
    },

    actionSetDataNavieraLinea({ commit }, data) {
      commit("setDataNavieraLinea", data);
    },

    actionSetDataNavieraCharter({ commit }, data) {
      commit("setDataNavieraCharter", data);
    },

    actionSetDataNavieraInttra({ commit }, data) {
      commit("setDataNavieraInttra", data);
    },

    /* Vista Productos */

    actionSetDataProductosNombres({ commit }, data) {
      commit("setDataProductosNombres", data);
    },

    actionSetDataProductosCategorias({ commit }, data) {
      commit("setDataProductosCategorias", data);
    },

    actionSetDataProductosContenedores({ commit }, data) {
      commit("setDataProductosContenedores", data);
    },

    actionSetDataProductosAgregarCategorias({ commit }, data) {
      commit("setDataProductosAgregarCategorias", data);
    },

    actionSetDataProductosAgregarContenedores({ commit }, data) {
      commit("setDataProductosAgregarContenedores", data);
    },

    /* Vista Embarcador */

    actionSetDataEmbarcadorNombres({ commit }, data) {
      commit("setDataEmbarcadorNombres", data);
    },

    actionSetDataEmbarcadorPaises({ commit }, data) {
      commit("setDataEmbarcadorPaises", data);
    },

    actionSetDataEmbarcadorTelefonos({ commit }, data) {
      commit("setDataEmbarcadorTelefonos", data);
    },

    /*
    
      Acciones auxiliares
    
    */
    actionSetDataEmbarcadores({ commit }, data) {
      commit("setDataEmbarcadores", data);
    },

    actionSetDataResponsables({ commit }, data) {
      commit("setDataResponsables", data);
    },

    actionSetDataTiposClientes({ commit }, data) {
      commit("setDataTiposClientes", data);
    },

    actionSetDataTiposModulosSistema({ commit }, data) {
      commit("setDataTiposModulosSistema", data);
    },

    actionSetDataClientesFiliales({ commit }, data) {
      commit("setDataClientesFiliales", data);
    },

    actionSetDataTiposProveedores({ commit }, data) {
      commit("setDataTiposProveedores", data);
    },

    // Modals editar campos clientes

    ActionSetVisibleModalEditarClientesContactos({ commit }, data) {
      commit("setVisibleModalEditarClientesContactos", data);
    },

    ActionSetVisibleModalEditarClientesDirecciones({ commit }, data) {
      commit("setVisibleModalEditarClientesDirecciones", data);
    },

    ActionSetVisibleModalEditarClientesPlantas({ commit }, data) {
      commit("setVisibleModalEditarClientesPlantas", data);
    },

    ActionSetVisibleModalEditarClientesAgenciasAduana({ commit }, data) {
      commit("setVisibleModalEditarClientesAgenciasAduana", data);
    },

    ActionSetVisibleModalEditarClientesConsignatarios({ commit }, data) {
      commit("setVisibleModalEditarClientesConsignatarios", data);
    },

    ActionSetVisibleModalEditarClientesNotificados({ commit }, data) {
      commit("setVisibleModalEditarClientesNotificados", data);
    },

    ActionSetVisibleModalEditarClientesAfiliados({ commit }, data) {
      commit("setVisibleModalEditarClientesAfiliados", data);
    },

    ActionSetVisibleModalEditarClientesProductos({ commit }, data) {
      commit("setVisibleModalEditarClientesProductos", data);
    },

    //  Acciones para ventanas editar Proveedores

    ActionSetVisibleModalEditarProveedoresCoordinadores({ commit }, data) {
      commit("setVisibleModalEditarProveedoresCoordinadores", data);
    },

    ActionSetVisibleModalEditarProveedoresConductores({ commit }, data) {
      commit("setVisibleModalEditarProveedoresConductores", data);
    },

    ActionSetVisibleModalEditarProveedoresCamiones({ commit }, data) {
      commit("setVisibleModalEditarProveedoresCamiones", data);
    },

    ActionSetVisibleModalEditarProveedoresDatosBancarios({ commit }, data) {
      commit("setVisibleModalEditarProveedoresDatosBancarios", data);
    },

    //  Acciones para ventanas editar Contenedores

    ActionSetVisibleModalEditarContenedoresContenedores({ commit }, data) {
      commit("setVisibleModalEditarContenedoresContenedores", data);
    },

    ActionSetVisibleModalEditarContenedoresDepositos({ commit }, data) {
      commit("setVisibleModalEditarContenedoresDepositos", data);
    },

    ActionSetVisibleModalEditarContenedoresAtmosferas({ commit }, data) {
      commit("setVisibleModalEditarContenedoresAtmosferas", data);
    },

    ActionSetVisibleModalEditarContenedoresTiposMovimiento({ commit }, data) {
      commit("setVisibleModalEditarContenedoresTiposMovimiento", data);
    },

    ActionSetVisibleModalEditarContenedoresZonasConsolidacion(
      { commit },
      data
    ) {
      commit("setVisibleModalEditarContenedoresZonasConsolidacion", data);
    },

    ActionSetVisibleModalEditarEmbarcadorDirecciones({ commit }, data) {
      commit("setVisibleModalEditarEmbarcadorDirecciones", data);
    },

    ActionSetVisibleModalEditarEmbarcadorContactos({ commit }, data) {
      commit("setVisibleModalEditarEmbarcadorContactos", data);
    },
    /*  

      Acciones para Temporadas
    
    */
    ActionSetVisibleModalEditarTemporada({ commit }, data) {
      commit("setVisibleModalEditarTemporada", data);
    },

    /*  

      Acciones para Datatables
    
    */
    actionSetDataFiliales({ commit }, data) {
      commit("setDataFiliales", data);
    },

    actionFilterDataFiliales({ commit }, data) {
      commit("filterDataFiliales", data);
    },

    actionLimpiarFilterDataFiliales({ commit }) {
      commit("limpiarDataFiliales");
    },

    actionSetvisibleModalInformacionGeneral({ commit }, data) {
      commit("setvisibleModalInformacionGeneral", data);
    },

    actionSetDataClientes({ commit }, data) {
      commit("setDataClientes", data);
    },

    actionFilterDataClientes({ commit }, data) {
      commit("filterDataClientes", data);
    },

    actionLimpiarFilterDataClientes({ commit }) {
      commit("limpiarDataClientes");
    },

    actionSetDataClientesContactos({ commit }, data) {
      commit("setDataClientesContactos", data);
    },

    actionSetDataClientesDirecciones({ commit }, data) {
      commit("setDataClientesDirecciones", data);
    },

    actionSetDataClientesPlantas({ commit }, data) {
      commit("setDataClientesPlantas", data);
    },

    actionSetDataClientesAgenciasAduana({ commit }, data) {
      commit("setDataClientesAgenciasAduana", data);
    },

    actionSetDataClientesConsignatarios({ commit }, data) {
      commit("setDataClientesConsignatarios", data);
    },

    actionSetDataClientesNotificados({ commit }, data) {
      commit("setDataClientesNotificados", data);
    },

    actionSetDataClientesAfiliados({ commit }, data) {
      commit("setDataClientesAfiliados", data);
    },

    actionSetDataClientesProductos({ commit }, data) {
      commit("setDataClientesProductos", data);
    },

    actionSetDataDetalleClientesContactos({ commit }, data) {
      commit("setDataDetalleClientesContactos", data);
    },

    actionSetDataDetalleClientesDirecciones({ commit }, data) {
      commit("setDataDetalleClientesDirecciones", data);
    },

    actionSetDataDetalleClientesPlantas({ commit }, data) {
      commit("setDataDetalleClientesPlantas", data);
    },

    actionSetDataDetalleClientesAgenciasAduana({ commit }, data) {
      commit("setDataDetalleClientesAgenciasAduana", data);
    },

    actionSetDataDetalleClientesConsignatarios({ commit }, data) {
      commit("setDataDetalleClientesConsignatarios", data);
    },

    actionSetDataDetalleClientesNotificados({ commit }, data) {
      commit("setDataDetalleClientesNotificados", data);
    },

    actionSetDataDetalleClientesAfiliados({ commit }, data) {
      commit("setDataDetalleClientesAfiliados", data);
    },

    actionSetDataDetalleClientesProductos({ commit }, data) {
      commit("setDataDetalleClientesProductos", data);
    },

    actionSetDataUsuarios({ commit }, data) {
      commit("setDataUsuarios", data);
    },

    actionFilterDataUsuarios({ commit }, data) {
      commit("filterDataUsuarios", data);
    },

    actionLimpiarFilterDataUsuarios({ commit }) {
      commit("limpiarDataUsuarios");
    },

    actionSetDataRoles({ commit }, data) {
      commit("setDataRoles", data);
    },

    actionSetDataProveedores({ commit }, data) {
      commit("setDataProveedores", data);
    },

    actionFilterDataProveedores({ commit }, data) {
      commit("filterDataProveedores", data);
    },

    actionSetDataProveedoresCoordinadores({ commit }, data) {
      commit("setDataProveedoresCoordinadores", data);
    },

    actionSetDataProveedoresConductores({ commit }, data) {
      commit("setDataProveedoresConductores", data);
    },

    actionSetDataProveedoresCamiones({ commit }, data) {
      commit("setDataProveedoresCamiones", data);
    },

    actionSetDataProveedoresDatosBancarios({ commit }, data) {
      commit("setDataProveedoresDatosBancarios", data);
    },

    actionLimpiarFilterDataProveedores({ commit }) {
      commit("limpiarDataProveedores");
    },

    actionSetDataMantenedorRegional({ commit }, data) {
      commit("setDataMantenedorRegional", data);
    },

    actionFilterDataMantenedorRegional({ commit }, data) {
      commit("filterDataMantenedorRegional", data);
    },

    actionLimpiarFilterDataMantenedorRegional({ commit }) {
      commit("limpiarDataMantenedorRegional");
    },

    actionSetDataPuertos({ commit }, data) {
      commit("setDataPuertos", data);
    },

    actionFilterDataPuertos({ commit }, data) {
      commit("filterDataPuertos", data);
    },

    actionLimpiarFilterDataPuertos({ commit }) {
      commit("limpiarDataPuertos");
    },

    actionSetDataDestinos({ commit }, data) {
      commit("setDataDestinos", data);
    },

    actionSetDataContenedores({ commit }, data) {
      commit("setDataContenedores", data);
    },

    actionFilterDataContenedores({ commit }, data) {
      commit("filterDataContenedores", data);
    },

    actionLimpiarFilterDataContenedores({ commit }) {
      commit("limpiarDataContenedores");
    },

    actionSetDataDepositos({ commit }, data) {
      commit("setDataDepositos", data);
    },

    actionFilterDataDepositos({ commit }, data) {
      commit("filterDataDepositos", data);
    },

    actionLimpiarFilterDataDepositos({ commit }) {
      commit("limpiarDataDepositos");
    },

    actionSetDataAtmosferas({ commit }, data) {
      commit("setDataAtmosferas", data);
    },

    actionSetDataMovimientos({ commit }, data) {
      commit("setDataMovimientos", data);
    },

    actionSetDataZonasConsolidacion({ commit }, data) {
      commit("setDataZonasConsolidacion", data);
    },

    actionSetDataPallets({ commit }, data) {
      commit("setDataPallets", data);
    },

    actionFilterDataPallets({ commit }, data) {
      commit("filterDataPallets", data);
    },

    actionLimpiarFilterDataPallets({ commit }) {
      commit("limpiarDataPallets");
    },

    actionSetDataCondiciones({ commit }, data) {
      commit("setDataCondiciones", data);
    },

    actionSetDataNaves({ commit }, data) {
      commit("setDataNaves", data);
    },

    actionFilterDataNaves({ commit }, data) {
      commit("filterDataNaves", data);
    },

    actionLimpiarFilterDataNaves({ commit }) {
      commit("limpiarDataNaves");
    },

    actionSetDataNavieras({ commit }, data) {
      commit("setDataNavieras", data);
    },

    actionFilterDataNavieras({ commit }, data) {
      commit("filterDataNavieras", data);
    },

    actionLimpiarFilterDataNavieras({ commit }) {
      commit("limpiarDataNavieras");
    },

    actionSetDataProductos({ commit }, data) {
      commit("setDataProductos", data);
    },

    actionFilterDataProductos({ commit }, data) {
      commit("filterDataProductos", data);
    },

    actionLimpiarFilterDataProductos({ commit }) {
      commit("limpiarDataProductos");
    },

    actionSetDataEmbarcador({ commit }, data) {
      commit("setDataEmbarcador", data);
    },

    actionFilterDataEmbarcador({ commit }, data) {
      commit("filterDataEmbarcador", data);
    },

    actionLimpiarFilterDataEmbarcador({ commit }) {
      commit("limpiarDataEmbarcador");
    },

    actionSetDataEmbarcadoresDirecciones({ commit }, data) {
      commit("setDataEmbarcadoresDirecciones", data);
    },

    actionSetDataEmbarcadoresContactos({ commit }, data) {
      commit("setDataEmbarcadoresContactos", data);
    },

    actionSetDataLimitePlanificaciones({ commit }, data) {
      commit("setDataLimitePlanificaciones", data);
    },

    actionSetDataTemporadas({ commit }, data) {
      commit("setDataTemporadas", data);
    },

    actionSetDataTemporadasTiers({ commit }, data) {
      commit("setDataTemporadasTiers", data);
    },

    actionSetDataTemporadasTipoTiers({ commit }, data) {
      commit("setDataTemporadasTipoTiers", data);
    },

    actionSetDataTemporadasNumeroTier({ commit }, data) {
      commit("setDataTemporadasNumeroTier", data);
    },

    actionSetDataEmpresas({ commit }, data) {
      commit("setDataEmpresas", data);
    },

    actionSetDataListaAgenciaAduana({ commit }, data) {
      commit("setDataListaAgenciaAduana", data);
    },
    actionSetDataDataListaClientes({ commit }, data) {
      commit("setDataDataListaClientes", data);
    },
    actionSetDataListaCategoriaProductoCliente({ commit }, data) {
      commit("setDataListaCategoriaProductoCliente", data);
    },
    actionSetUserStructure({ commit }, data) {
      commit("setUserStructure", data);
    },
    actionSetTiers({ commit }, data) {
      commit("setTiers", data);
    },
    actionSetLoadingTableTiersAdmin({ commit }, data) {
      commit("setLoadingTableTiersAdmin", data);
    },

    actionSetShowModalEditarTier({ commit }, data) {
      commit("setShowModalEditarTier", data);
    },


    actionSetDataRegiones({ commit }, data) {
      commit("setDataRegiones", data);
    },
    actionSetDataProvincias({ commit }, data) {
      commit("setDataProvincias", data);
    },
    actionSetDataComunas({ commit }, data) {
      commit("setDataComunas", data);
    },
    actionSetDataLocalidades({ commit }, data) {
      commit("setDataLocalidades", data);
    },
  },
};
